import { useEffect } from 'react';

export const useScript = (
  url: string,
  ref: React.MutableRefObject<HTMLElement | null>,
  id?: string,
) => {
  useEffect(() => {
    if (ref && ref.current) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = url;
      script.id = id ?? '';
      ref.current.appendChild(script);
    }
  }, [url, ref]);
};
